import React, { PureComponent, Fragment } from 'react'
import cx from 'classnames'
import moment from 'moment'
import { formatPrice } from 'helpers'

import { Grid, Cell } from 'components/layout/grid'
import Button from 'components/ui/Button/Button'
import Box from 'components/layout/Box/Box'


class ServicesReport extends PureComponent {

  state = {
    node: null,
  }

  componentDidMount() {
    const encodedUri  = this.getEncodeUri()
    const link        = document.createElement('a')

    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${this.getTitle()}.csv`)

    document.body.appendChild(link)

    this.setState({ node: link })
  }

  componentWillUnmount() {
    const { node } = this.state

    document.body.removeChild(node)
  }

  getTitle = () => {
    const { from, to } = this.props

    const date = `с ${moment(from, 'DDMMYYYY').format('DD.MM.YYYY')} по ${moment(to, 'DDMMYYYY').format('DD.MM.YYYY')}`

    return `Отчет: Продажи услуг ${date}`
  }

  getEncodeUri = () => {
    const { statistic: { items, itemsTotal, total } } = this.props

    let encodeData = 'data:text/csv;charset=utf-8,\uFEFF'

    const rows = []

    rows.push([ this.getTitle() ])
    rows.push([
      '№', 'Название услуги', 'Тариф', 'Дата', 'Дата возврата', 'Сумма',
    ])

    Object.keys(items).forEach((key, index) => {
      items[key].forEach(({ payed, date, canceledAt, tariffCategoryName }, itemIndex) => {
        rows.push([
          index + 1,
          Boolean(key === 'subscriptions') ? 'Разовые посещения' : key,
          (tariffCategoryName || '').replace(/"/g, '\'').replace(/;/g, ''),
          date,
          canceledAt,
          formatPrice(payed / 100, false).replace('.', ','),
        ])
      })

      rows.push([
        'Подытог',
        formatPrice(itemsTotal[key], false).replace('.', ','),
      ])
    })

    rows.push([
      'Итого',
      formatPrice(total / 100, false).replace('.', ','),
    ])

    return `${encodeData}${
      rows.map((items) => (
        items.map((item) => String(item || '')).join(';')
      ))
        .join('\n')
      }`
  }

  handleButtonClick = () => {
    const { node } = this.state
    const { onClose } = this.props

    node.click()
    onClose()
  }

  render() {
    const {
      className, titleClassName, buttonClassName, darkClassName, darkestClassName,
      statistic: { items, itemsTotal, total }, isEmpty,
    } = this.props

    let currentIndex = 1

    return (
      <div className={className}>
        <Box pb="md">
          <div className={titleClassName}>{this.getTitle()}</div>
        </Box>
        {
          isEmpty ? (
            <div>Нет статистики по выбранным условиям</div>
          ) : (
            <Fragment>
              {
                Object.keys(items).map((key, index) => (
                  <Fragment key={key}>
                    {
                      items[key].map(({ payed, date, canceledAt, tariffCategoryName }, itemIndex) => (
                        <Fragment key={`${index}${itemIndex}`}>
                          {
                            Boolean(!index && !itemIndex) && (
                              <Grid className={darkClassName} columns={11} gutter="md">
                                <Cell size={1}>№</Cell>
                                <Cell size={2}>Название услуги</Cell>
                                <Cell size={2}>Тариф</Cell>
                                <Cell size={2}>Дата</Cell>
                                <Cell size={2}>Дата возврата</Cell>
                                <Cell size={2}>Сумма</Cell>
                              </Grid>
                            )
                          }
                          <Grid className={cx({ [darkClassName]: index % 2 !== 0 })} columns={11} gutter="md">
                            <Cell size={1}>
                              {currentIndex++}
                            </Cell>
                            <Cell size={2}>
                              {
                                Boolean(key === 'subscriptions') ? (
                                  <span>Разовые посещения</span>
                                ) : (
                                  <span>{key}</span>
                                )
                              }
                            </Cell>
                            <Cell size={2}>
                              <span dangerouslySetInnerHTML={{ __html: tariffCategoryName }} />
                            </Cell>
                            <Cell size={2}>
                              {date}
                            </Cell>
                            <Cell size={2}>
                              {canceledAt}
                            </Cell>
                            <Cell size={2}>
                              {formatPrice(payed)}
                            </Cell>
                          </Grid>
                        </Fragment>
                      ))
                    }
                    <Grid columns={1} gutter="md">
                      {
                        Boolean(key === 'subscriptions') ? (
                          <Cell size={1}><b>Подытог: {formatPrice(itemsTotal[key])}</b></Cell>
                        ) : (
                          <Cell size={1}><b>Подытог: {formatPrice(itemsTotal[key])}</b></Cell>
                        )
                      }
                    </Grid>
                  </Fragment>
                ))
              }
              <Box pt="md">
                <Grid columns={1} gutter="md">
                  <Cell size={1}><b>Итого: {formatPrice(total)}</b></Cell>
                </Grid>
              </Box>
              <Box pt="md">
                <Button
                  className={buttonClassName}
                  title="Сохранить в файл"
                  green
                  onClick={this.handleButtonClick}
                />
              </Box>
            </Fragment>
          )
        }
      </div>
    )
  }
}


export default ServicesReport
